// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/omsconsts.proto (package aurora.core.consts.oms, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/omsconsts.proto.
 */
export const file_consts_omsconsts: GenFile = /*@__PURE__*/
  fileDesc("ChZjb25zdHMvb21zY29uc3RzLnByb3RvEhZhdXJvcmEuY29yZS5jb25zdHMub21zKo0BCg5PbXNPcmRlclN0YXR1cxIcChhVTlNQRUNJRklFRF9PUkRFUl9TVEFUVVMQABIICgRPUEVOEAESCgoGRklMTEVEEAISDAoIQ0FOQ0VMRUQQAxILCgdFWFBJUkVEEAQSDgoKVEVSTUlOQVRFRBAFEggKBEhFTEQQBhISCg5GT1JDRV9DQU5DRUxFRBAHKkEKDE9tc09yZGVyVHlwZRIaChZVTlNQRUNJRklFRF9PUkRFUl9UWVBFEAASCQoFTElNSVQQARIKCgZNQVJLRVQQAio+CgtPcmRlckludGVudBIcChhVTlNQRUNJRklFRF9PUkRFUl9JTlRFTlQQABIICgRGSVJNEAESBwoDSU9JEAIqkQEKEk9tc1RpbWVJbkZvcmNlVHlwZRIdChlVTlNQRUNJRklFRF9USU1FX0lOX0ZPUkNFEAASBwoDREFZEAESFAoQR09PRF9USUxMX0NBTkNFTBACEhcKE0lNTUVESUFURV9PUl9DQU5DRUwQAxIQCgxGSUxMX09SX0tJTEwQBBISCg5HT09EX1RJTExfVElNRRAFKlYKDVJvdXRpbmdTdGF0dXMSHgoaVU5TUEVDSUZJRURfUk9VVElOR19TVEFUVVMQABIKCgZST1VURUQQARIMCghVTlJPVVRFRBACEgsKB1BFTkRJTkcQAypNChBJbnN0cnVtZW50SWRUeXBlEiIKHlVOU1BFQ0lGSUVEX0lOU1RSVU1FTlRfSURfVFlQRRAAEgkKBUNVU0lQEAESCgoGVElDS0VSEAJCKVonZ2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvY29uc3RzYgZwcm90bzM");

/**
 * @generated from enum aurora.core.consts.oms.OmsOrderStatus
 */
export enum OmsOrderStatus {
  /**
   * UNSPECIFIED_ORDER_STATUS will be set when a value is specified that is not defined in the schema
   * and should be treated as an error.
   *
   * @generated from enum value: UNSPECIFIED_ORDER_STATUS = 0;
   */
  UNSPECIFIED_ORDER_STATUS = 0,

  /**
   * @generated from enum value: OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: FILLED = 2;
   */
  FILLED = 2,

  /**
   * @generated from enum value: CANCELED = 3;
   */
  CANCELED = 3,

  /**
   * @generated from enum value: EXPIRED = 4;
   */
  EXPIRED = 4,

  /**
   * @generated from enum value: TERMINATED = 5;
   */
  TERMINATED = 5,

  /**
   * @generated from enum value: HELD = 6;
   */
  HELD = 6,

  /**
   * @generated from enum value: FORCE_CANCELED = 7;
   */
  FORCE_CANCELED = 7,
}

/**
 * Describes the enum aurora.core.consts.oms.OmsOrderStatus.
 */
export const OmsOrderStatusSchema: GenEnum<OmsOrderStatus> = /*@__PURE__*/
  enumDesc(file_consts_omsconsts, 0);

/**
 * @generated from enum aurora.core.consts.oms.OmsOrderType
 */
export enum OmsOrderType {
  /**
   * UnspecifiedOrderType will be set when a value is specified that is not defined in the schema
   * and should be treated as an error.
   * UNDOCUMENTED-RPC
   *
   * @generated from enum value: UNSPECIFIED_ORDER_TYPE = 0;
   */
  UNSPECIFIED_ORDER_TYPE = 0,

  /**
   * @generated from enum value: LIMIT = 1;
   */
  LIMIT = 1,

  /**
   * @generated from enum value: MARKET = 2;
   */
  MARKET = 2,
}

/**
 * Describes the enum aurora.core.consts.oms.OmsOrderType.
 */
export const OmsOrderTypeSchema: GenEnum<OmsOrderType> = /*@__PURE__*/
  enumDesc(file_consts_omsconsts, 1);

/**
 * @generated from enum aurora.core.consts.oms.OrderIntent
 */
export enum OrderIntent {
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from enum value: UNSPECIFIED_ORDER_INTENT = 0;
   */
  UNSPECIFIED_ORDER_INTENT = 0,

  /**
   * @generated from enum value: FIRM = 1;
   */
  FIRM = 1,

  /**
   * @generated from enum value: IOI = 2;
   */
  IOI = 2,
}

/**
 * Describes the enum aurora.core.consts.oms.OrderIntent.
 */
export const OrderIntentSchema: GenEnum<OrderIntent> = /*@__PURE__*/
  enumDesc(file_consts_omsconsts, 2);

/**
 * @generated from enum aurora.core.consts.oms.OmsTimeInForceType
 */
export enum OmsTimeInForceType {
  /**
   * UnspecifiedTimeInForce will be set when a value is specified that is not defined in the schema
   * and should be treated as an error.
   * UNDOCUMENTED-RPC
   *
   * @generated from enum value: UNSPECIFIED_TIME_IN_FORCE = 0;
   */
  UNSPECIFIED_TIME_IN_FORCE = 0,

  /**
   * @generated from enum value: DAY = 1;
   */
  DAY = 1,

  /**
   * @generated from enum value: GOOD_TILL_CANCEL = 2;
   */
  GOOD_TILL_CANCEL = 2,

  /**
   * @generated from enum value: IMMEDIATE_OR_CANCEL = 3;
   */
  IMMEDIATE_OR_CANCEL = 3,

  /**
   * @generated from enum value: FILL_OR_KILL = 4;
   */
  FILL_OR_KILL = 4,

  /**
   * @generated from enum value: GOOD_TILL_TIME = 5;
   */
  GOOD_TILL_TIME = 5,
}

/**
 * Describes the enum aurora.core.consts.oms.OmsTimeInForceType.
 */
export const OmsTimeInForceTypeSchema: GenEnum<OmsTimeInForceType> = /*@__PURE__*/
  enumDesc(file_consts_omsconsts, 3);

/**
 * deprecated
 *
 * @generated from enum aurora.core.consts.oms.RoutingStatus
 */
export enum RoutingStatus {
  /**
   * UnspecifiedRoutingStatus will be set when a value is specified that is not defined in the schema
   * and should be treated as an error.
   * UNDOCUMENTED-RPC
   *
   * @generated from enum value: UNSPECIFIED_ROUTING_STATUS = 0;
   */
  UNSPECIFIED_ROUTING_STATUS = 0,

  /**
   * @generated from enum value: ROUTED = 1;
   */
  ROUTED = 1,

  /**
   * @generated from enum value: UNROUTED = 2;
   */
  UNROUTED = 2,

  /**
   * @generated from enum value: PENDING = 3;
   */
  PENDING = 3,
}

/**
 * Describes the enum aurora.core.consts.oms.RoutingStatus.
 */
export const RoutingStatusSchema: GenEnum<RoutingStatus> = /*@__PURE__*/
  enumDesc(file_consts_omsconsts, 4);

/**
 * @generated from enum aurora.core.consts.oms.InstrumentIdType
 */
export enum InstrumentIdType {
  /**
   * UNDOCUMENTED-RPC
   *
   * @generated from enum value: UNSPECIFIED_INSTRUMENT_ID_TYPE = 0;
   */
  UNSPECIFIED_INSTRUMENT_ID_TYPE = 0,

  /**
   * @generated from enum value: CUSIP = 1;
   */
  CUSIP = 1,

  /**
   * @generated from enum value: TICKER = 2;
   */
  TICKER = 2,
}

/**
 * Describes the enum aurora.core.consts.oms.InstrumentIdType.
 */
export const InstrumentIdTypeSchema: GenEnum<InstrumentIdType> = /*@__PURE__*/
  enumDesc(file_consts_omsconsts, 5);

